import { render, staticRenderFns } from "./CustomPaymentTabModal.vue?vue&type=template&id=493e833a&scoped=true&"
import script from "./CustomPaymentTabModal.vue?vue&type=script&lang=js&"
export * from "./CustomPaymentTabModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomPaymentTabModal.vue?vue&type=style&index=0&id=493e833a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493e833a",
  null
  
)

export default component.exports